<template>
  <section class="contact-data">
    <form @submit.prevent="atualizarDadosPaciente" class="form-template">
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('contato.email')">
            <b-input
              name="email"
              v-model.lazy="email"
              :placeholder="emailPlaceholder"
              @input="isReady()"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('contato.telefone1')">
            <b-input
              v-model.lazy="celular"
              name="phone1"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :placeholder="phonePlaceholder"
              @input="isReady()"
            />
          </b-field>
          <div class="field">
            <b-checkbox v-model.lazy="whatsappOptin" @input="isReady()">
              {{ checkboxDesc }}
            </b-checkbox>
          </div>
        </div>
        <div class="column">
          <b-field :label="this.$t('contato.telefone2')" class="opcional">
            <b-input
              v-model.lazy="telefone"
              name="phone2"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :placeholder="phonePlaceholder"
              @input="isReady()"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4 is-offset-8">
          <div class="field">
            <button
              :disabled="disabledButton"
              class="button button-primary"
              type="submit"
            >
              {{ $t('botoes.atualizar') }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <b-loading :is-full-page="true" :active.sync="isLoading" />
    <modal-template v-if="showModal" class="override-modal">
      <template #header>
        <h2>{{ modalInfo.titulo }}</h2>
      </template>
      <template #body>
        <p>{{ modalInfo.subtitulo }}</p>
      </template>
      <template #footer>
        <button
          id="loginmodal"
          class="button button-primary"
          @click="toggleInfoModal"
        >
          {{ modalInfo.btnTexto }}
        </button>
      </template>
    </modal-template>
  </section>
</template>

<script>
import router from '@/router'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { SET_LOADING } from '@/store/modules/mutation-types'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  components: {
    ModalTemplate
  },
  data() {
    return {
      celular: this.paciente.Celular,
      email: this.paciente.Email,
      telefone: this.paciente.TelefoneOpcional,
      whatsappOptin: this.paciente.WhatsappOptin,
      commonPlaceholder: this.$t('placeholders.common'),
      emailPlaceholder: this.$t('placeholders.email'),
      phonePlaceholder: this.$t('placeholders.phone'),
      checkboxDesc: this.$t('contato.optin'),
      disabledButton: true,
      showModal: false,
      modalInfo: { titulo: '', subtitulo: '', btnTexto: '' }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loadingAuth'
    })
  },
  props: {
    paciente: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapMutations([SET_LOADING]),
    ...mapActions(['atualizarContato']),
    mostrarModal(titulo, subtitulo, textoBotao, acaoBotao) {
      this.modalInfo = {
        titulo: titulo,
        subtitulo: subtitulo,
        btnTexto: textoBotao,
        acaoBotao: acaoBotao
      }
      this.showModal = !this.showModal
    },
    errorText(titulo, mensagem) {
      this.mostrarModal(
        titulo,
        mensagem,
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    atualizarDadosPaciente() {
      this.SET_LOADING(true)
      var contato = {
        CodigoPessoa: this.paciente.Codigo,
        Celular: this.celular,
        Email: this.email,
        Telefone: this.telefone,
        WhatsappOptin: this.whatsappOptin
      }
      this.atualizarContato(contato)
        .then(() => {
          this.paciente.Celular = this.celular
          this.paciente.Email = this.email
          this.paciente.Telefone = this.telefone
          this.paciente.WhatsappOptin = this.whatsappOptin
          this.mostrarModal(
            this.$t('mensagens.sucesso'),
            this.$t('mensagens.dados-atualizados'),
            this.$t('botoes.confirmar')
          )
        })
        .catch((err) => {
          if (err instanceof NotAuthenticatedError) {
            router.push('/')
          } else {
            if (err.errors) {
              this.errorText(err.detail, err.errors[0])
            } else {
              this.errorText('Erro', err.detail)
            }
          }
        })
        .finally(() => this.SET_LOADING(false))
      this.disabledButton = true
    },
    isReady() {
      this.disabledButton = !this.emailECelularPreenchidos()
    },
    emailECelularPreenchidos() {
      var emailPreenchido = this.email != null && this.email !== ''
      var celularPreenchido = this.celular != null && this.celular !== ''

      return emailPreenchido & celularPreenchido
    },
    toggleInfoModal() {
      this.showModal = !this.showModal
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.contact-data {
  padding-right: 5.3125rem;
  padding-left: 5.3125rem;
  .button[type='submit'] {
    margin-top: 1.875rem;
  }
}
@media (max-width: 64rem) {
  .contact-data {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
